<!-- Share a link Modal -->
<div class="modal-content">
  <div class="modal-body">
    <div class="fc_modal_body" [formGroup]="form">
      <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="modal.dismissAll()"></button>
      <h3 class="h3 my-3">Who do you want to share the upload link with?</h3>
      <form action="#" method="get" class="fc_form" formGroupName="otherIndividuals">
        <div class="single-row">
          <div class="form-group mb-3">
            <label for="fname" class="form-label"><span class="required">*</span>First name</label>
            <input type="text" class="form-control  " formControlName="firstName" placeholder="First Name" (keyup)="
              form.controls['forFamilyCentralMembers'].setValue(false)
            " />
            </div>
            <div class="form-group mb-3">
              <label for="lname" class="form-label"><span class="required">*</span>Last name</label>
            <input type="text" class="form-control  " formControlName="lastName" placeholder="Last Name" (keyup)="
                      form.controls['forFamilyCentralMembers'].setValue(false)
                    " />
              </div>
            </div>
            <div class="form-group mb-3">
              <label for="emergeny_email" class="form-label"><span class="required">*</span>Email address</label>
              <input type="email" class="form-control  " formControlName="email" maxlength="50" placeholder="Email Address"
                name="emergeny_email" />
              </div>
              <div class="form-group-phone mb-3">
                <label for="phone" class="form-label"><span class="required">*</span>Phone number</label>
                <app-phone-input [form]="form.controls.otherIndividuals"></app-phone-input>
              </div>
              <div class="form-group mb-3">
                <label for="phone" class="form-label"><span class="required">*</span>Valid Until</label>
                <select class="form-select" aria-label="Valid Till" [required]="!form.value.NeverExpires"
                  formControlName="deliveryDate" id="dp">
                  <option value="" disabled>Valid Until</option>
                  @for (opt of linkExpireTime; track opt) {
                    <option [value]="opt.key">
                      {{ opt.value }}
                    </option>
                  }
                </select>
              </div>
              <div class="form-group d-flex justify-content-between align-items-center mb-0">
                <button type="button" class="border_btn" data-bs-dismiss="modal" (click)="modal.dismissAll()">Cancel</button>
          <button type="submit" class="primary_btn" (click)="sharelink()" disableDuringAjax [disabled]="
          !executor && form.controls['forFamilyCentralMembers'].value
        ">Share</button>
              </div>
            </form>
          </div>
        </div>
      </div>